import { authErrorHandler } from '@/services/error/authHandler.js';
import { showNotification } from '@/plugins/notification';
import router from '../../router';
import { fetchUserUnreadPosts } from '@/services/apis/postApi';

export default {
  async fetchDraftPosts({ commit }, channelId) {
    const response = await fetch(`/api/draft-posts?&channelId=${channelId}`);
    let draftPosts = await response.json();
    if (draftPosts.statusCode) {
      authErrorHandler(draftPosts);
    }
    commit('setDraftPosts', draftPosts.reverse());
    return draftPosts;
  },
  async saveDraftPost({ commit }, payload) {
    if (payload.mentions) {
      payload.mentions = payload.mentions.filter(
        (obj, idx, arr) => idx === arr.findIndex(t => t.userId === obj.userId),
      );
    }
    let response = await fetch(`/api/draft-posts`, {
      method: 'POST',
      body: JSON.stringify({
        channelId: payload.channelId,
        title: payload.title ? payload.title : undefined,
        rawText: payload.rawText ? payload.rawText : undefined,
        text: payload.text,
        attachedFilesIds: payload.attachedFilesIds ? payload.attachedFilesIds : undefined,
        mentions: payload.mentions ? payload.mentions : undefined,
        urls: payload.urls?.[0]
          ? [
              {
                url: payload.urls[0].url,
                title: payload.urls[0].title,
                description: payload.urls[0].description,
                imageUrl: payload.urls[0].imageUrl,
              },
            ]
          : undefined,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response.status === 401 || response.status === 403) {
      authErrorHandler(response);
    }
    return response;
  },

  addDataDraftPost({ commit }, post) {
    commit('addDataDraft', post);
  },

  async deleteDraftPost({ commit }, id) {
    const response = await fetch(`/api/draft-posts/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response.status) {
      authErrorHandler(response);
    }
    if (response.ok) {
      commit('deleteDraftPost', id);
    }
    return response;
  },

  async fetchLoginBluesky({ commit }, payload) {
    let response = await fetch(`/api/auth/login-bluesky/request-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    let res = await response.json();
    return res;
  },
  async logInWithBluesky({ commit }, { iss, state, code }) {
    try {
      let response = await fetch(`/api/users/connect-bluesky`, {
        method: 'POST',
        body: JSON.stringify({
          iss,
          state,
          code,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (!data?.statusCode) {
        if (!data.id || data.id === 'null') {
          console.error('User ID is required', new Error().stack);
          return;
        }
        let response = await fetch(`/api/users/${data.id}`);
        let profile = await response.json();
        if (!profile.weighInThresholds[0]) {
          let arr = [1, 2, 3, 4, 5];
          arr.forEach(item => {
            profile.weighInThresholds.push({ threshold: 'off' });
          });
        }
        localStorage.setItem('user', JSON.stringify(profile));
        localStorage.setItem('isPostToBluesky', 'true');
        router.push('/');
        showNotification(
          'success',
          `Bluesky Account Connected!`,
          'Your Bluesky account has been successfully connected. Your posts will now be automatically published to Bluesky.',
          7000,
        );
        commit('setUserData', profile);
        return data;
      } else {
        showNotification('error', `Error`, data.message, 7000);
        commit('setUserDataError', data);
        return data;
      }
    } catch (error) {
      console.log('error', error);
      commit('setUserDataError', error.message);
    }
  },
  async fetchDisconnectBluesky({ commit }) {
    try {
      let response = await fetch(`/api/users/disconnect-bluesky`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (!data.statusCode) {
        if (!data.id || data.id === 'null') {
          console.error('User ID is required', new Error().stack);
          return;
        }
        let response = await fetch(`/api/users/${data.id}`);
        let profile = await response.json();
        if (!profile.weighInThresholds[0]) {
          let arr = [1, 2, 3, 4, 5];
          arr.forEach(item => {
            profile.weighInThresholds.push({ threshold: 'off' });
          });
        }
        localStorage.setItem('user', JSON.stringify(profile));
        localStorage.removeItem('isPostToBluesky');
        router.push('/');
        commit('setUserData', profile);
        return data;
      } else {
        commit('setUserDataError', data);
        return data;
      }
    } catch (error) {
      console.log('error', error);
      commit('setUserDataError', error.message);
    }
  },
};
